export default __webpack_public_path__ + "static/media/proj1.1c3196c9.png";